var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0C229.68 0 0 229.68 0 512s229.68 512 512 512 512-229.68 512-512S794.32 0 512 0zm0 949.437C270.8 949.437 74.564 753.2 74.564 512S270.8 74.566 512 74.566 949.436 270.8 949.436 512 753.2 949.438 512 949.438zm-353.217-135.75l653.68-653.68 52.713 52.714-653.68 653.68-52.713-52.714z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/ban.478c82fe33395836f6090a2cc4145f4a.svg";
export { ForwardRef as ReactComponent };